import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileStickyCTA } from './MobileStickyCTA';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-334">
      <Header data-id="element-335" />
      <main className="flex-1 pb-16 lg:pb-0" data-id="element-336">{children}</main>
      <Footer data-id="element-337" />
      <MobileStickyCTA data-id="element-338" />
    </div>;
}